<div class="footer-section">
  <span class="footer-text">Copyright © {{CurrentYear}} Jai Baba Balak
    Nath</span>
</div>